import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Wind, Activity, Sparkles, Heart } from 'lucide-react';
import { useLanguage } from '../components/LanguageContext';
import { translations } from '../translations';
import { RetreatCarousel } from '../components/RetreatCarousel';
export function Retreats() {
  const {
    language
  } = useLanguage();
  const t = translations.retreats[language];
  // Existing Sense & Sensuality Carousel State
  const slideImages = ['https://cdn.magicpatterns.com/uploads/ewfTooUruwR1GZHCmzrK3D/2R7A1900_20.jpg', 'https://cdn.magicpatterns.com/uploads/gvCvBW1MSCQg9427GrzAmR/2R7A1952.jpg', 'https://cdn.magicpatterns.com/uploads/5o9jtugjaGntvvkUmEf4sY/2R7A21682B(1).jpg'];
  const [currentSlide, setCurrentSlide] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % slideImages.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);
  // Past Retreats — 4 independent carousel data sets
  const pastRetreats = [{
    title: 'Kawau Island',
    images: ['https://cdn.magicpatterns.com/uploads/wEnSdykUC9nrRXnmyKTFep/WhatsApp_Image_2026-04-23_at_3.25.14_PM_(2).jpg', 'https://cdn.magicpatterns.com/uploads/jAcWog5yrHUAtGyPH7BtEP/WhatsApp_Image_2026-04-23_at_3.25.12_PM_(3).jpg', 'https://cdn.magicpatterns.com/uploads/aN8bspu8XsdhfndAsMW2e9/WhatsApp_Image_2026-04-23_at_3.25.13_PM.jpg', 'https://cdn.magicpatterns.com/uploads/6TeBGTpxez24K76mcPYdnk/WhatsApp_Image_2026-04-23_at_3.25.12_PM_(1).jpg', 'https://cdn.magicpatterns.com/uploads/3jyCj9HwqhKfUPPApD448J/WhatsApp_Image_2026-04-23_at_3.25.15_PM.jpg']
  }, {
    title: 'Bali Garden',
    images: ['https://cdn.magicpatterns.com/uploads/rhTVN14nhe5CGWDPjuRVfk/WhatsApp_Image_2026-04-23_at_3.38.35_PM.jpg', 'https://cdn.magicpatterns.com/uploads/2k4RSXiAcnnWkm58FyubPs/WhatsApp_Image_2026-04-23_at_3.25.09_PM_(1).jpg', 'https://cdn.magicpatterns.com/uploads/2wwDJekW3c9NUKcXvFzi6i/WhatsApp_Image_2026-04-23_at_3.25.08_PM.jpg', 'https://cdn.magicpatterns.com/uploads/tPLDL3jwvhmH2rDXoPFqLM/WhatsApp_Image_2026-04-23_at_3.25.09_PM.jpg', 'https://cdn.magicpatterns.com/uploads/eTcU6MfjzuETnp78rn826E/WhatsApp_Image_2026-04-23_at_3.25.07_PM_(2).jpg']
  }, {
    title: 'Sacred Earth Center',
    images: ['https://cdn.magicpatterns.com/uploads/fRRc8oja3UmgzYiSJZxQUu/WhatsApp_Image_2026-04-23_at_3.24.59_PM_(2).jpg', 'https://cdn.magicpatterns.com/uploads/5cA9bLEyDMpGvGQuH2Fkxb/WhatsApp_Image_2026-04-23_at_3.25.05_PM_(1).jpg', 'https://cdn.magicpatterns.com/uploads/xdhqZbHW2VprnHSQm9Yfnm/WhatsApp_Image_2026-04-23_at_3.25.04_PM_(1).jpg', 'https://cdn.magicpatterns.com/uploads/1GqLEQKV1b8qgKp2fMiWNa/WhatsApp_Image_2026-04-23_at_3.24.59_PM.jpg', 'https://cdn.magicpatterns.com/uploads/eVkLmhojumHTejA2nETqL4/WhatsApp_Image_2026-04-23_at_3.25.03_PM.jpg']
  }, {
    title: 'Kula Muriwai',
    images: ['https://cdn.magicpatterns.com/uploads/4dHm7s9NBzzj8WDyn3unrV/WhatsApp_Image_2026-04-23_at_3.24.57_PM_(2).jpg', 'https://cdn.magicpatterns.com/uploads/feFJ4CfE5qQpktuffjmbvF/WhatsApp_Image_2026-04-23_at_3.24.58_PM_(2).jpg', 'https://cdn.magicpatterns.com/uploads/uFztxGscChL83oZPdmm4z2/WhatsApp_Image_2026-04-23_at_3.24.57_PM.jpg', 'https://cdn.magicpatterns.com/uploads/fEhxULTbbttoX3rnUBGQMG/WhatsApp_Image_2026-04-23_at_3.24.57_PM_(1).jpg']
  }];
  return <AnimatePresence mode="wait" data-id="element-182" data-mp="9n34fyt1vh68">
      <motion.div key={language} initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.5
    }} className="w-full bg-dark" data-id="element-183" data-mp="ek3d8hhaay11">
        {/* 1. Lilithisis Retreat (Moved to Top) */}
        <section className="relative min-h-screen flex flex-col" data-id="element-184" data-mp="8vl7textmp6o">
          {/* Hero Section */}
          <div className="relative h-[70vh] w-full" data-id="element-185" data-mp="4v1bueozhrm4">
            <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
            backgroundImage: 'url("https://images.unsplash.com/photo-1518241353330-0f7941c2d9b5?w=1600&q=80")'
          }} data-id="element-186" data-mp="3w0knxiuwjsw5" />
            <div className="absolute inset-0 bg-dark/70" data-id="element-187" data-mp="3m4hnqijm24bu" />

            <div className="absolute inset-0 flex flex-col justify-center items-center text-center px-6" data-id="element-188" data-mp="3hb4zi9iufzjm">
              <motion.h2 initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.8
            }} className="md:text-7xl text-cream mb-4 text-[80px] font-[500] font-[Cinzel,_serif]" data-id="element-189" data-mp="3dauqsp3o2v12">
                Lilithisis
              </motion.h2>
              <motion.p initial={{
              opacity: 0
            }} whileInView={{
              opacity: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.8,
              delay: 0.3
            }} className="text-rose font-inter text-sm md:text-base uppercase tracking-[0.3em]" data-id="element-190" data-mp="2y6s2dzlb0lus">
                Sacred Feminine Retreats
              </motion.p>
            </div>
          </div>

          {/* Content & Pillars */}
          <div className="bg-dark py-24 px-6 md:px-12" data-id="element-191" data-mp="1mr3e94wbdgse">
            <div className="max-w-5xl mx-auto w-full" data-id="element-192" data-mp="1rr99sw5pfnfr">
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.8
            }} className="text-center mb-20" data-id="element-193" data-mp="1rpy4grwm27mj">
                <p className="text-cream/80 font-cormorant text-xl md:text-2xl leading-relaxed max-w-3xl mx-auto mb-12" data-id="element-194" data-mp="10rfkhowytlxh">
                  Step out of the ordinary into a sacred space of renewal. This
                  is your invitation to slow down, soften, and remember who you
                  truly are. In the stillness of nature and the embrace of
                  sisterhood, rise into the fullness of your being.
                </p>
                <Link to="/contact" data-id="element-195" data-mp="2m3pawx6lbo00">
                  <button className="btn-outline-gold" data-id="element-196" data-mp="2m6v52qu2tg2l">
                    {t.discoverCta || 'Discover More'}
                  </button>
                </Link>
              </motion.div>

              {/* 4 Pillars */}
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.8,
              delay: 0.2
            }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-24" data-id="element-197" data-mp="2to9sd2fkrglz">
                {[{
                icon: Wind,
                title: 'Breathwork & Meditation'
              }, {
                icon: Activity,
                title: 'Dance Therapy & Somatic Movement'
              }, {
                icon: Sparkles,
                title: 'Healing Practices & Rituals'
              }, {
                icon: Heart,
                title: 'Sacred Temple Space & Sisterhood'
              }].map((pillar, idx) => <div key={idx} className="flex flex-col items-center text-center p-6 border border-white/5 bg-white/[0.02] hover:bg-white/[0.04] transition-colors duration-300" data-id="element-198" data-mp="2wq4ii5zrhhc4" data-mpi={idx}>
                    <pillar.icon className="w-8 h-8 text-gold mb-6" strokeWidth={1.5} data-id="element-199" data-mp="3pbnwuwfnuwvb" />
                    <h4 className="text-cream font-cinzel text-lg tracking-wide" data-id="element-200" data-mp="3ferl8hugtumj">
                      {pillar.title}
                    </h4>
                  </div>)}
              </motion.div>

              {/* Past Retreats — 4 Independent Carousels */}
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.8,
              delay: 0.4
            }} className="max-w-6xl mx-auto" data-id="element-201" data-mp="1z1kndujmw6b3">
                <h3 className="text-2xl md:text-3xl font-cinzel text-gold text-center mb-10" data-id="element-202" data-mp="t9zkhiqgilk4">
                  Past Retreats
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6" data-id="element-203" data-mp="127te2lwu713l">
                  {pastRetreats.map((retreat, idx) => <RetreatCarousel key={idx} title={retreat.title} images={retreat.images} autoPlayInterval={5000 + idx * 700} data-id="element-204" data-mp="1764k0lk0grgj" data-mpi={idx} />)}
                </div>
              </motion.div>
            </div>
          </div>
        </section>

        {/* 2. Sense & Sensuality Retreat (Moved below Lilithisis) */}
        <section className="relative min-h-screen flex flex-col border-t-[0.5px] border-white/5" data-id="element-205" data-mp="2yx501qt3m8rj">
          <div className="relative h-[70vh] w-full" data-id="element-206" data-mp="33w853b92wezi">
            <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
            backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/rcjJYVcRhSmfbAs6YuHsLW/IMG_9577.jpg")'
          }} data-id="element-207" data-mp="33yud1bzvswi9" />
            <div className="absolute inset-0 bg-dark/60" data-id="element-208" data-mp="3huy1sprzkcnc" />

            <div className="absolute inset-0 flex flex-col justify-center items-center text-center px-6" data-id="element-209" data-mp="3mmpkyf8tbg3g">
              <motion.h2 initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.8
            }} className="text-5xl md:text-7xl font-cinzel text-cream mb-4" data-id="element-210" data-mp="3rmlnea1v2zgw">
                {t.sense.title}
              </motion.h2>
              <motion.p initial={{
              opacity: 0
            }} whileInView={{
              opacity: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.8,
              delay: 0.3
            }} className="text-rose font-inter text-sm md:text-base uppercase tracking-[0.3em]" data-id="element-211" data-mp="1fz8rmb9gds0t">
                {t.sense.subtitle}
              </motion.p>
            </div>
          </div>

          <div className="bg-dark py-32 px-6 md:px-12 flex-grow flex items-center" data-id="element-212" data-mp="2rf71uigdak3m">
            <div className="max-w-6xl mx-auto w-full" data-id="element-213" data-mp="2mn5iydop1v4m">
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.8
            }} className="flex flex-col gap-16" data-id="element-214" data-mp="2mlkqqupuqo9x">
                {/* Editorial Header */}
                <div className="text-center max-w-3xl mx-auto" data-id="element-215" data-mp="2mviz07usnpon">
                  <h3 className="text-3xl md:text-4xl font-cinzel text-gold mb-4" data-id="element-216" data-mp="2rt2bb27xlsdy">
                    Couple Retreat
                  </h3>
                  <p className="text-rose md:text-base uppercase tracking-[0.2em] mb-8 text-[14px] font-[400] font-[Inter,_sans-serif]" data-id="element-217" data-mp="2duuh322a556h">
                    3 days of eco-luxe accommodation on the peaceful Kawau
                    Island, plant-based nourishment, and ritual spaces.
                  </p>
                  <div className="h-[1px] w-24 bg-gold/30 mx-auto mb-8" data-id="element-218" data-mp="20kr1tun6ss5o" />
                  <p className="text-cream/90 font-inter text-lg leading-relaxed font-light" data-id="element-219" data-mp="20ioczdxrt52j">
                    Moving beyond the 'talking cure', this retreat was designed
                    to deepen intimate connection through movement, somatic
                    exploration, and the wisdom of the body. A safe, private
                    space at Parohe Island to rediscover desire and playfulness.
                  </p>
                </div>

                {/* Content Grid */}
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16 items-start mt-8" data-id="element-220" data-mp="2f9dqwo2m8ya3">
                  {/* Left Column: Image Carousel */}
                  <div className="md:col-span-5 h-full" data-id="element-221" data-mp="2o9turyn9u7fh">
                    <div className="w-full aspect-[4/5] relative overflow-hidden border border-white/10" data-id="element-222" data-mp="2o88urti6twa8">
                      <AnimatePresence mode="wait" data-id="element-223" data-mp="yx8emz6ffeum">
                        <motion.img key={currentSlide} src={slideImages[currentSlide]} alt="Retreat photography" initial={{
                        opacity: 0
                      }} animate={{
                        opacity: 1
                      }} exit={{
                        opacity: 0
                      }} transition={{
                        duration: 0.8
                      }} className="absolute inset-0 w-full h-full object-cover" data-id="element-224" data-mp="txdm6r706h7g" />
                      </AnimatePresence>
                      {/* Slide indicators */}
                      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 z-10" data-id="element-225" data-mp="rdh0tm13tvmk">
                        {slideImages.map((_, idx) => <button key={idx} onClick={() => setCurrentSlide(idx)} className={`w-2 h-2 rounded-full transition-all duration-300 ${idx === currentSlide ? 'bg-gold w-6' : 'bg-white/40'}`} aria-label={`Go to slide ${idx + 1}`} data-id="element-226" data-mp="3v0fzhhb1owx1" data-mpi={idx} />)}
                      </div>
                    </div>
                  </div>

                  {/* Right Column: Details */}
                  <div className="md:col-span-7 flex flex-col justify-center space-y-12" data-id="element-227" data-mp="34jnmizyuo7sy">
                    {/* Key Learning Points */}
                    <div data-id="element-228" data-mp="2zpt0hpvrvgqp">
                      <h4 className="text-xl font-cinzel text-gold mb-6 border-b border-white/10 pb-4" data-id="element-229" data-mp="2usj9i5sqix0r">
                        Key Learning Points
                      </h4>
                      <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-cream/70 font-inter text-sm" data-id="element-230" data-mp="2prv8qsepf1tc">
                        {t.sense.bullets.map((bullet, idx) => <li key={idx} className="flex items-start" data-id="element-231" data-mp="2gttdyulkd5ei" data-mpi={idx}>
                            <span className="text-gold mr-3 mt-0.5" data-id="element-232" data-mp="266v24nljks8f">✧</span>
                            <span className="leading-relaxed" data-id="element-233" data-mp="2b7irl4u4h10j">{bullet}</span>
                          </li>)}
                      </ul>
                    </div>

                    {/* Facilitators */}
                    <div data-id="element-234" data-mp="227cgtqpt6f52">
                      <h4 className="text-xl font-cinzel text-gold mb-4 border-b border-white/10 pb-4" data-id="element-235" data-mp="226kwjc1nw3u3">
                        Facilitators
                      </h4>
                      <p className="text-cream/80 font-inter text-sm leading-relaxed" data-id="element-236" data-mp="2twfo7fczs5lx">
                        Co-created with{' '}
                        <span className="text-cream font-medium" data-id="element-237" data-mp="2g5u4jofprrmz">
                          Steven Dromgool
                        </span>{' '}
                        — the Clinical Director of Relate and founder of the
                        Presence Oriented Relationship Therapy (PORT). He has
                        been involved in Men's work for over 30 years and
                        specialises in helping couples restore their connection
                        after betrayal.
                      </p>
                    </div>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </section>

        {/* 3. Personalised Retreat (Kept at bottom) */}
        <section className="bg-charcoal py-32 px-6 md:px-12 border-t-[0.5px] border-white/5" data-id="element-238" data-mp="3rtcmike4fgpk">
          <div className="max-w-4xl mx-auto text-center" data-id="element-239" data-mp="3438rv2iwurap">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-240" data-mp="3015do64ux8lq">
              <h2 className="text-4xl md:text-5xl font-cinzel text-cream mb-6" data-id="element-241" data-mp="ob2s1rmqbmb0">
                {t.custom.title}
              </h2>
              <div className="h-[1px] w-16 bg-gold mx-auto mb-12" data-id="element-242" data-mp="2is2w7lvf3cx6" />

              <p className="text-cream/80 font-inter text-base leading-relaxed mb-12 font-light" data-id="element-243" data-mp="2mrbp6oimv6ro">
                {'I offer fully customized retreats designed to meet you exactly where you are and gently guide you toward where your soul longs to go. Each experience is crafted intuitively, drawing on modalities such as ritual, embodiment, somatic work, and nature connection.\n\nThis is not a pre-made program; it is a container made specifically for you, your pace, and your season of life. Every journey begins with a conversation to tune into your unique intentions.'}
              </p>

              <Link to="/contact" data-id="element-244" data-mp="3fg8ttotx951y">
                <button className="btn-outline-rose" data-id="element-245" data-mp="1g3o891byf28g">{t.custom.cta}</button>
              </Link>
            </motion.div>
          </div>
        </section>
      </motion.div>
    </AnimatePresence>;
}